import React, { useState } from "react";
import TextAnimation from "../components/scroll-text";

export default function AboutSchool() {
	const [infoAboutTheSchool, setInfoAboutTheSchool] = useState(
		`Sacred Heart School is a dynamic and premier educational institute dedicated to fostering academic achievements, personal growth and social responsibility. The school is situated in Chümoukedima District Nagaland at 5th mile, Model village strategically located near the NH29 providing easy access and connectivity.`
	);
	const [infoAboutTheSchool2, setInfoAboutTheSchool2] = useState(
		`The school was established in the year 1984 by the visionary Late Hosal Angami who established a legacy of excellence in education. The school got its recognition and permission order for class 9 and 10 on dated 10th September 1997 as a co-educational English medium high school. It follows the curriculum prescribed by the NBSE.`
	);
	const [infoAboutTheSchool3, setInfoAboutTheSchool3] = useState(
		`The school management is entrusted by the reputable board of trustees, supported by a dedicated admistrative team. The school’s first management board was headed by the co-founder as the chairman Mr. Hosal Angami along with the board of trustees-
Mr. Francis Thomas(Principal and secretary)
Mr. Hito Visa Arbitrator 
Mr. Puda (Pastor) Member
Mr. Pukrocho(V.C. Chairman) Member
Mr. Khradi (V.C. Secretary) Member.
The school has achieved a major landmark completing 25th glorious years in the year 2009.
`
	);
	return (
		<section className=" bg-blue-theme py-12">
			<div className="flex flex-col bg-white rounded shadow-lg py-12 md:flex-row items-center gap-8 mb-12">
				<div className="mx-4 md:mx-8 text-justify">
					<h3 className="text-2xl font-bold text-theme mb-4">
						<TextAnimation text="About the school" />
					</h3>
					<p className="text-gray-700 leading-relaxed my-3">
                    <span className="font-bold">Sacred Heart School</span> is a dynamic and premier educational institution dedicated to fostering academic achievements, personal growth and social responsibility. The school is situated in <span className="font-bold">Chümoukedima District Nagaland at 5th mile, Model Village</span> strategically located near the NH29 providing easy access and connectivity.
						{/* <TextAnimation text={infoAboutTheSchool} /> */}
						{/* <TextAnimation text={infoAboutTheSchool2} /> */}
					</p>
					<h3 className="text-2xl font-bold text-theme mt-4">
						<TextAnimation text="History of the School" />
					</h3>
					<p className="text-gray-700 leading-relaxed my-3">
						The school was established in the year 1984 by a visionary Late Hosal Angami who established a legacy of excellence in education. The school got its recognition and permission order for class 9 and 10 on dated 10th September, 1997 as a co-educational English Medium High School. It follows the curriculum prescribed by the NBSE.
					</p>
					<p className="text-gray-700 leading-relaxed my-3">
						The school management is entrusted to a reputable board
						of trustees, supported by a dedicated admistrative team.
						The school's first management board was headed by the
						co-founder as <span className="font-bold">the chairman Mr. Hosal Angami</span> along with
						the board of trustees-
						<ul className="list-disc mx-6">
							<li className="my-3"><div className="flex flex-col"><span className="font-bold">Mr. Francis Thomas </span><span>(Principal and Secretary)</span></div></li>
							<li className="my-3"><div className="flex flex-col"><span className="font-bold">Mr. Hito Visa </span><span>Arbitrator </span></div></li>
							<li className="my-3"><div className="flex flex-col"><span className="font-bold">Mr. Puda </span><span>(Pastor) Member</span></div></li>
							<li className="my-3"><div className="flex flex-col"><span className="font-bold">Mr. Pukrocho </span><span>(V.C. Chairman) Member</span></div></li>
							<li className="my-3"><div className="flex flex-col"><span className="font-bold">Mr. Khradi </span><span>(V.C. Secretary) Member.</span></div></li>
						</ul>
                        The school has achieved a major landmark completing 25th glorious years in the year 2009.
					</p>
				</div>
			</div>
		</section>
	);
}
